import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="bg-white py-6 px-4 md:px-8" data-id="element-146">
      <div className="max-w-2xl mx-auto" data-id="element-147">
        <FadeIn data-id="element-148">
          <div className="border-l-4 border-forest pl-5 py-1" data-id="element-149">
            <p className="text-sm md:text-base font-serif italic text-charcoal leading-relaxed" data-id="element-150">
              You know that moment. The sun hits your face, you open your eyes,
              and for a split second, everything is peaceful.
              <br data-id="element-151" />
              <br data-id="element-152" />
              Then, you try to move.
              <br data-id="element-153" />
              <br data-id="element-154" />
              Your fingers feel tight and puffy. Your knees "crunch" as you
              swing your legs out of bed. Your lower back feels like a rusted
              hinge. You haven't even had your coffee yet, and you're already
              negotiating with your own body just to get to the kitchen.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}